"use client";

import { motion } from "framer-motion";
import { useMediaQuery } from "@mui/material";

import SectionLoader from "@/components/ui/SectionLoader";
import { fadeUp, defaultViewport } from "@/utils/animations";

import "./OurServices.scss";

/** Shimmer for Strapi service banners (4th–6th) when CMS data is missing or failed. */
export default function OurServicesBannersSkeleton() {
  const isMobile = useMediaQuery("(max-width:1023px)");

  if (isMobile) {
    return (
      <div className="py-4">
        <div className="flex gap-4">
          <SectionLoader minHeight="200px" style={{ width: "78%", flexShrink: 0 }} />
          <SectionLoader minHeight="200px" style={{ width: "78%", flexShrink: 0 }} />
          <SectionLoader minHeight="200px" style={{ width: "78%", flexShrink: 0 }} />
        </div>
      </div>
    );
  }

  return (
    <motion.div
      className="third-section"
      variants={fadeUp}
      initial="hidden"
      whileInView="visible"
      viewport={defaultViewport}
    >
      <div className="left">
        <SectionLoader minHeight="min(45vh, 380px)" style={{ height: "100%", minHeight: "280px" }} />
      </div>
      <div className="right">
        <div className="top">
          <SectionLoader minHeight="100%" style={{ minHeight: 160, height: "100%" }} />
        </div>
        <div className="bottom">
          <SectionLoader minHeight="100%" style={{ minHeight: 160, height: "100%" }} />
        </div>
      </div>
    </motion.div>
  );
}
